
type STYPE = 'inner' | 'outer'
// 系统类型，区分内外包项目
let $sType = 'inner'


const prodHostNameMap = {
    'inner': 'mpc.pm.netease.com',
    'outer': 'mpc.netease.com',
}

function setSType(type: STYPE) {
    $sType = type
}

function isProdHostName() {
    const hostName = window.location.hostname?.toLowerCase();
    return prodHostNameMap[$sType] === hostName;
}

export {
    $sType,
    setSType,
    isProdHostName,
}
